// AUTOGENERATED FILE
// source: scripts/generate-product-types-templates.ts

import React from 'react'
import { ReactComponent as TemplateSVG } from '../../../../../assets/product-templates/svg/cake-box-template.svg'

export const CakeBoxTemplate = (props: React.SVGProps<SVGSVGElement>) => {
  return <TemplateSVG {...props} />
}
